import { useEffect, useState } from "react";
import terminalRuntimeConfig from "../Constants/terminalRuntimeConfig";

// export function useIsNightTime( startHour = 20, endHour = 7, updateIntervalMs = 60000) { // default: 1 minute
//   const [isNight, setIsNight] = useState(false);

//   useEffect(() => {
//     const checkTime = () => {
//       const now = new Date();
//       const hour = now.getHours();

//       // Night is from 20:00 to next day at 07:00
//       const night = hour >= startHour || hour < endHour;
//       setIsNight(night);
//     };

//     checkTime(); // run immediately
//     const interval = setInterval(checkTime, updateIntervalMs);

//     return () => clearInterval(interval);
//   }, [updateIntervalMs]);

//   return isNight;
// }


function parseTimeString(timeStr) {
  if (!timeStr || typeof timeStr !== "string") return null;
  const parts = timeStr.split(":");
  if (parts.length < 2) return null;
  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  if (isNaN(h) || isNaN(m)) return null;
  return { hour: h, minute: m };
}

export function useIsNightTime(
  nighttimeStart,
  nighttimeEnd,
  updateIntervalMs = 50000
) {
  const defaultStartHour = 20;
  const defaultStartMinute = 0;
  const defaultEndHour = 6;
  const defaultEndMinute = 58;

  const parsedStart = parseTimeString(nighttimeStart);
  const parsedEnd = parseTimeString(nighttimeEnd);

  const startHour = parsedStart ? parsedStart.hour : defaultStartHour;
  const startMinute = parsedStart ? parsedStart.minute : defaultStartMinute;
  const endHour = parsedEnd ? parsedEnd.hour : defaultEndHour;
  const endMinute = parsedEnd ? parsedEnd.minute : defaultEndMinute;

  const [isNight, setIsNight] = useState(false);

  useEffect(() => {
    if (!terminalRuntimeConfig.useNightTime) return;
    const checkTime = () => {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();

      const currentTotal = hour * 60 + minute;
      const startTotal = startHour * 60 + startMinute;
      const endTotal = endHour * 60 + endMinute;

      let night = false;

      if (startTotal < endTotal) {
        night = currentTotal >= startTotal && currentTotal < endTotal;
      } else {
        // Interval crosses midnight (e.g. 20:00 → 07:00)
        night = currentTotal >= startTotal || currentTotal < endTotal;
      }

      setIsNight(night);
    };

    checkTime();
    const interval = setInterval(checkTime, updateIntervalMs);

    return () => clearInterval(interval);
  }, [startHour, startMinute, endHour, endMinute, updateIntervalMs]);

  return isNight;
}